import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export interface BenefitsResult {
  data?: any;
  loading: boolean;
  error?: string;
}

export const useBenefits = (
  state?: string,
  tier?: number,
  uhcEligibilityStatus?: string,
  enabled: boolean = true
): BenefitsResult => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (!enabled || tier === undefined) return;

    const load = async () => {
      try {
        setLoading(true);
        setError(undefined);

        const benefitsRes = await client.get(
          "/EmployeeInformation/EligibleBenefits",
          {
            params: {
              state,
              tier,
              nonExempt: tier === 0 ? "true" : "false"
            }
          }
        );

        const benefits = benefitsRes.data;

        // Attach UHC from employee hook
        benefits.UHCEligibilityStatus = uhcEligibilityStatus;

        setData(benefits);
      } catch (err) {
        console.error(err);
        setError("Failed to load benefits.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [state, tier, uhcEligibilityStatus, enabled, client]);

  return { data, loading, error };
};